import React, {useEffect} from 'react';
import { Modal } from "@mui/material";
import Fade from '@mui/material/Fade';
import View from '@modul-connect/shared/components/atoms/view'
import { H1, P } from '@modul-connect/shared/components/atoms/text'
import TextField from '@modul-connect/shared/components/molecules/textField'
import Button from '@modul-connect/shared/components/atoms/button';
import modal from '@modul-connect/shared/components/atoms/modal'

const ModalEditCode = ({
    openModal,
    onClose,
    editCode,
    existingRow,
    disabled,
    onSubmit
}) => {
    const [code, setCode] = React.useState(existingRow[0] ? existingRow[0].from_code : 0)
    const [errorDescription, setErrorDescription] = React.useState(false)
    const [description, setDescription] = React.useState(existingRow[0]?.description || "")

    useEffect(() => {
        if(openModal) {
            setErrorDescription(false)
            setDescription(existingRow[0]?.description || "")
            setCode(existingRow[0] ? existingRow[0].code : 0)
        }
    }, [openModal, existingRow])

    const isName = (name) => {
      if(!name) return false
      if(!name.trim().length) return false
      
      return true
    }

    const onSave = () => {
        let hasErrors = false
        setErrorDescription(false)

        if(!isName(description)) {
          setErrorDescription(true)
          hasErrors = true
        }

        if(hasErrors) {
            return
        }

        if (existingRow) {
          const data = {
            code: code,
            description: description
          }

          editCode(data)
          onSubmit(data)
          onClose()
        }

    }

    return (
        <Modal
            open={ openModal }
            onClose={(event, reason) => {
              if (disabled && reason === 'backdropClick') {
                return
              }
              onClose()
            }}            
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
        >
            <Fade in={ openModal }>
                <div >
                    <View extend={ modal.container }>
                        <View extend={ modal.header }>
                            <H1 text={"Update Code"}/>
                        </View>
                        <View extend={{ ...modal.content, marginTop: '0'}}>
                            <TextField
                                name="Code"
                                placeholder=""
                                disabled={true}
                                value={code}
                            />
                            <TextField
                                name="Description"
                                placeholder=""
                                disabled={ disabled }
                                error={errorDescription}
                                onChange={e => setDescription(e.target.value)}
                                value={description}
                            />
                            <TextField
                                name="Provider (Section)"
                                placeholder="No provider in this range"
                                disabled={ true }
                                value={existingRow[1]}
                            />
                        </View>
                        <View extend={ modal.footer }>
                            <Button noBg cancel disabled={ disabled } onClick={ () => onClose() }>
                                Cancel
                            </Button>
                            <Button noBg noPadding disabled={ disabled } onClick={ onSave }>
                                Submit
                            </Button>
                        </View>
                    </View>
                </div>
            </Fade>
        </Modal>
    )
}

export default ModalEditCode;